import { APP_PART_TYPES } from "@lhd/features/Apps/AppForm/constants";

export const EXCEPT_HIDE_NAMES = [APP_PART_TYPES.LABEL] as string[]; //rowId === 2 ! is_hide_name

export const EXCEPT_REQUIRED_FIELDS = [
  //rowId === 3 ! is_required_field
  APP_PART_TYPES.LABEL,
  APP_PART_TYPES.RADIO_BUTTON,
  APP_PART_TYPES.TABLE,
  APP_PART_TYPES.FIELD_GROUP,
  APP_PART_TYPES.CREATED_BY,
  APP_PART_TYPES.UPDATED_BY,
  APP_PART_TYPES.CREATED_DATETIME,
  APP_PART_TYPES.UPDATED_DATETIME,
  APP_PART_TYPES.RECORD_NUMBER,
  APP_PART_TYPES.EMPLOYEE_SIGNATURE,
] as string[];

export const EXCEPT_SHOW_COLUMNS = [
  //rowId === 4 ! is_show_column
  APP_PART_TYPES.TABLE,
  APP_PART_TYPES.FIELD_GROUP,
  APP_PART_TYPES.CREATED_BY,
  APP_PART_TYPES.UPDATED_BY,
  APP_PART_TYPES.CREATED_DATETIME,
  APP_PART_TYPES.UPDATED_DATETIME,
  APP_PART_TYPES.RECORD_NUMBER,
] as string[];

export const DUPLICATE_VALUES = [
  //rowId === 8  is_prohibit_duplicate_values
  APP_PART_TYPES.DATE_AND_TIME,
  APP_PART_TYPES.DATE,
  APP_PART_TYPES.LINK,
  APP_PART_TYPES.NUMBER,
  APP_PART_TYPES.TEXT,
] as string[];

export const EXCEPT_DEFAULT_VALUES = [
  APP_PART_TYPES.LABEL,
  APP_PART_TYPES.TABLE,
  APP_PART_TYPES.FIELD_GROUP,
  APP_PART_TYPES.CREATED_BY,
  APP_PART_TYPES.UPDATED_BY,
  APP_PART_TYPES.CREATED_DATETIME,
  APP_PART_TYPES.UPDATED_DATETIME,
  APP_PART_TYPES.RECORD_NUMBER,
  APP_PART_TYPES.ATTACHMENT,
  APP_PART_TYPES.MULTI_CHOICE,
  APP_PART_TYPES.PRIMARY_COMPANY_NAME,
  APP_PART_TYPES.ORGANIZATION_SELECTION,
  APP_PART_TYPES.WORKER_SELECTION,
  APP_PART_TYPES.BRANCH_SELECTION,
  APP_PART_TYPES.DEPARTMENT_SELECTION,
  APP_PART_TYPES.DIVISION_SELECTION,
  APP_PART_TYPES.COMPANY_LOCATION_SELECTION,
  APP_PART_TYPES.REPRESENTATIVE_SELECTION,
  APP_PART_TYPES.COMPANY_PHONE_NUMBER_SELECTION,
  APP_PART_TYPES.POSITION_SELECTION,
  APP_PART_TYPES.CUSTOMER_SELECTION,
  APP_PART_TYPES.EMPLOYEE_SIGNATURE,
  APP_PART_TYPES.CHECK_BOX,
  APP_PART_TYPES.RADIO_BUTTON,
] as string[];

// hide filter/sort icon on list and sheet headers
export const HIDDEN_FILTER_APP_PART_TYPES = [
  APP_PART_TYPES.ATTACHMENT,
  APP_PART_TYPES.PRIMARY_COMPANY_NAME,
  APP_PART_TYPES.EMPLOYEE_SIGNATURE,
  APP_PART_TYPES.TABLE,
  APP_PART_TYPES.LOOKUP,
  APP_PART_TYPES.CALCULATED,
  APP_PART_TYPES.RELATED_RECORDS,
  APP_PART_TYPES.SIGNATURE,
  APP_PART_TYPES.LABEL,
  APP_PART_TYPES.HORIZONTAL_BORDER,
  APP_PART_TYPES.VERTICAL_BORDER,
  APP_PART_TYPES.FIELD_GROUP,
  APP_PART_TYPES.BLANK_SPACE,
] as string[];

// hide columns at sheet and table list record
export const HIDDENS_COLUMNS_SHEET = [
  APP_PART_TYPES.LABEL,
  APP_PART_TYPES.HORIZONTAL_BORDER,
  APP_PART_TYPES.VERTICAL_BORDER,
  APP_PART_TYPES.TABLE,
  APP_PART_TYPES.FIELD_GROUP,
  APP_PART_TYPES.SIGNATURE,
  APP_PART_TYPES.SIGNED_DATE,
] as string[];

export const RECORD_TYPE = {
  VIEW: "view",
};

export const SHOULD_PREVENT_SHOW_CONTINUE_USING_BIZ_SHEET_MODAL_PARAM =
  "shouldPreventShowContinueUsingBizSheetModal";
